import { render, staticRenderFns } from "./articlePreview.vue?vue&type=template&id=598cb974&scoped=true&"
import script from "./articlePreview.vue?vue&type=script&lang=js&"
export * from "./articlePreview.vue?vue&type=script&lang=js&"
import style0 from "./articlePreview.vue?vue&type=style&index=0&id=598cb974&prod&lang=scss&scoped=true&"
import style1 from "./articlePreview.vue?vue&type=style&index=1&id=598cb974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598cb974",
  null
  
)

export default component.exports